<template>
    <div 
      class="editorProcess" 
    >
      <div 
        class="canvas" 
        id="editor-process-readonly" 
        ref="processCanvas"
      >
      </div>
      <editorOptions :diagram="diagram" >
        <div class="diagramAddOn">
          <div class="overviewWrap" :class="{on: overviewStatus}">
<!--            <button class="mapOpen"  @click="overviewStatus = !overviewStatus">Map</button>-->
            <div id="editor-overview" class="overview"></div>
          </div>
        </div>
      </editorOptions>
      <contextMenuTemplate @contextMounted="getContext" :slctType="slctType" :readonlyFlag="true"/>
      <Loading :visible="loading" />
    </div>
  </template>
  
  <script>
  
  import { createNamespacedHelpers } from 'vuex';
  import CommNew,{ commNewMapMutations , commNewMapGetters } from "@processEditor/CommNew";
  import mixin from "@/mixins/process";
  import GO from "gojs";
  
  import editorOptions from "@nav_process/Editor/options";
  import contextMenuTemplate from "@nav_process/Editor/contextMenu";
  import Loading from '@common/loading.vue';


  const ProcessSelector = createNamespacedHelpers('ProcessSearch');
  const ProcessEditor = createNamespacedHelpers('ProcessEditor');
  const Hub = createNamespacedHelpers('Hub');
  const goMake = GO.GraphObject.make;
  
  export default {
    mixins:[mixin , CommNew],
    data () {
      return {
        processData: {},
        goMake: {},
        diagram: {},
        overview: {},
        overviewStatus: false,
        loading: false,
        contextMenu: {},
        slctType : 'single',
      }
    },
    components:{
      Loading,
      editorOptions, 
      contextMenuTemplate, 
    },
    computed: {
      ...commNewMapGetters([
        'status' , 
      ]) ,
      ...ProcessSelector.mapGetters(['getSelectedProcess']),
      // ...ProcessEditor.mapGetters(['getSelectedNode']),
      ...ProcessEditor.mapState({
        selectedNode: state => state.selectedNode
      }) ,
    },
    watch: {
      getSelectedProcess(value) {
        this.processData = value;
        this.getProcessDetail();
      }, 
      PROCESS_INFO: {
        deep: true,
        handler(value) {
          // console.log('Editor Process info watch: ', value)
          Object.assign(this.processData, value)
          this.getProcessDetail()
        },
      },
    },
    mounted() {
      Object.assign(this.processData, this.PROCESS_INFO)
      this.diagramInit();
      this.updateStatus({ nodeinfoViewBln : false }) ; 
      // this.getProcessDetail()
      // window.addEventListener('beforeunload', (e)=> {
      //   e.preventDefault();
      //   e.returnValue = '';
      //   this.saveDiagram()
      // });
    },
    methods: {
      ...commNewMapMutations([
        'updateStatus' , 'initDiagram'
      ]),
      ...ProcessEditor.mapMutations(['selectNode', 'setProcessId', 'setDiagram', 'setProcessDetail']),
      ...Hub.mapActions([
        'updateSelectedProcess',
      ]),
      ...Hub.mapMutations(
        [
          "setConnectProtocolObj",
          "setVisualizationPopObj",
        ]
      ),
      callConnectProtocol(nodeData){
        this.setConnectProtocolObj({
          openFlag: true,
          dataObj: {
            ...nodeData
          }
        })
        // 시각화 임시
        // this.setVisualizationPopObj({
        //   openFlag: true,
        //   dataObj: {
        //     ...nodeData
        //   }
        // })
      },
      async getProcessDetail() {
        this.loading = true
        try {
          const response = await this.$wApi.process.release.get({
            processId : this.$route.query.processId
          });
          const data = JSON.parse(response.content)

          if (data == null) {
            Object.assign(
                    this.processData, {
                      ...this.processData,
                      links: [],
                      nodes: [],
                    }
            )
          } else {
            Object.assign(this.processData, data)
          }

          //노드 순서 적용
          let keyLinkRes = await this.$wApi.dictionary.getReleaseDictionaryKeyLinksByReleaseProcessId({
            idReleaseProcess : response.idReleaseProcess
          });
          // 연결 프로토콜 개수
          let protocolDataList = await this.$wApi.process.getProtocols(null, this.$route.query.processId);
          
          this.processData.nodes.forEach((node,index) => {
            let link = keyLinkRes.filter(o => o.tagKey === node.key)
            if(link.length > 0){
              node.nodeOrder = link[0]?.nodeOrder;
              node.nodeForceOrder = link[0]?.nodeForceOrder;
            }
            // 연결 프로토콜 개수
            if(protocolDataList != null) {
              const protocolCount = protocolDataList.filter(o => o.innerKeyOfProtocol == node.key).length;
              node.protocolData = {cnt: protocolCount};
              node.protocol = protocolCount;
            }
          })

          this.setProcessDetail(this.processData)
          await this.updateSelectedProcess(this.processData);
          this.setModel(this.processData)
          this.loading = false
        } catch (error) {
          this.loading = false
        }
        this.loading = false
      },
      diagramInit() {
        // diagram 설정
        // console.log("Diagram Initialization start : ", this.contextMenu)
        const nodeTemplateMapped = new GO.Map();
  
        this.releaseDiagram();
        this.refreshNodeStyleMap();
        this.nodeStyleMap.forEach((nodeData, key)=>{
          nodeTemplateMapped.add(
            `${key}`,
            goMake(
              GO.Node, 'Spot', {
                cursor: 'pointer',
                margin:2,
                locationSpot: GO.Spot.Center,
                // selectionAdornmentTemplate : this.nodeStyle.selection(),
                // click: (event, node ) =>{
                //   node.data.visible = null;
                //   this.selectNode(node.data);
                // },
                click: (event, node ) =>{
                  this.selectNode(node.data);
                },
                doubleClick: (event, node)=>{
                  this.callConnectProtocol(node.data);
                },
                contextMenu: this.contextMenu,
              },
              new GO.Binding("location", "position", GO.Point.parse).makeTwoWay(GO.Point.stringify),
              goMake(GO.Panel,'Auto', 
                ...nodeData.nodeTemplate,
              ),
            ),
          )
        })
        
        this.diagram = new GO.Diagram("editor-process-readonly", {
          layout: goMake(GO.LayeredDigraphLayout, {
            isOngoing: false,
            isInitial: false
          }),
          // layout: goMake(GO.TreeLayout),
          "undoManager.isEnabled": true,
          // 확대 정도
          scale: 1,
          maxScale: 3,
          minScale: 0.2,
          nodeTemplateMap: nodeTemplateMapped,
          linkTemplate: this.linkTemplate,
          // groupTemplate: this.groupTemplate,
        });
        
        this.diagram.isVirtualized  = true
        // this.diagram.contextMenu = this.contextMenu
        this.diagram.isReadOnly = true;

        //디버깅용!
        this.diagram.addDiagramListener("ObjectSingleClicked", function(e) {
            var selectedNodes = e.diagram.selection; //현재 선택된 요소들의 컬렉션

            selectedNodes.each(function(node) {
                var data = node.data; // 선택된 노드의 데이터
                var key = data.key; // 선택된 노드의 키 속성 값
                //console.log(JSON.stringify(data));
            });
        });

        this.diagram.addDiagramListener('ChangedSelection', (event, node) => {
          if (this.diagram.selection.size === 0) {
            this.selectNode({visible: false})
          };

          // 컨텍스트 메뉴를 싱글/멀티/그룹으로 나눈다.
          if (this.diagram.selection.size === 1) {
            const selectedNode = this.diagram.selection.first();
            this.slctType = (selectedNode instanceof go.Group) ? 'group' : 'single';
          } else if (this.diagram.selection.size > 1) {
            this.slctType = 'multiple';
          } else {
            this.slctType = 'single';
          }
        });

        // Overview 설정(minimap)
        this.overview = new GO.Overview('editor-overview', {
          observed: this.diagram
        })
        
        this.setDiagram(this.diagram)
  
        this.$emit("update-diagram", this.diagram);
        this.initDiagram( this.diagram )

      },
      setModel(item) {
        // console.log('Set model: ', item)
        if ( item.links == undefined ) {
          item.links = [] ; 
        }
        if ( item.nodes == undefined ) {
          item.nodes = [] ; 
        }
  
        for(let nodeData of item.nodes){
          nodeData.linkValidation = this.nodeStyleMap.get(nodeData.category).linkValidation
        }

        // 모델 설정
        this.diagram.model = new GO.GraphLinksModel(
          {
            nodeDataArray: item.nodes,
            linkDataArray: item.links,
          }
        );

        // 렌더링이 완료된 후 경로 재계산 (약간의 지연을 두고 호출)
        setTimeout(() => {
          this.diagram.links.each(function(link) {
            link.invalidateRoute(); // 경로 재계산
          });
        }, 1000);  // 0ms로 지연

      },
      getContext(data) {
        this.contextMenu = data;
        // console.log('Get context : ', data);
      },
      closeBrowser() {
  
      }
    }
  }
  
  </script>
  
<style lang="scss">
  @import '@nav_process/Editor/index.scss';
</style>
